import { render } from "./collection-selected-tags.vue?vue&type=template&id=6b463914&scoped=true"
import script from "./collection-selected-tags.vue?vue&type=script&lang=js"
export * from "./collection-selected-tags.vue?vue&type=script&lang=js"

import "./collection-selected-tags.vue?vue&type=style&index=0&id=6b463914&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b463914"]])

export default __exports__